import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    amount: 'Amount',
    bic: 'BIC',
    iban: 'IBAN',
    new: 'New',
    userLabel: 'User Label',
  },
  fr: {
    amount: 'Montant du virement',
    bic: 'BIC',
    iban: 'IBAN',
    new: 'Nouveau',
    userLabel: 'Référence du virement (label)',
  },
} as const);

export default locales;
